import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable({
  providedIn: 'root'
})
export class OwnerService {
  owners = [];
  //  = [
  //   { ownerId: 'Adam Fromal', deadSalary: 0 },
  //   { ownerId: 'Alex Bowe', deadSalary: 0 },
  //   { ownerId: 'Alex Hoffman', deadSalary: 0 },
  //   { ownerId: 'Arjun Baradwaj', deadSalary: 0 },
  //   { ownerId: 'Bretton McIlrath', deadSalary: 0 },
  //   { ownerId: 'Brian Huang', deadSalary: 0 },
  //   { ownerId: 'Connor Godbout', deadSalary: 0 },
  //   { ownerId: 'Ed Newman', deadSalary: 0 },
  //   { ownerId: 'Karthik Nathan', deadSalary: 0 },
  //   { ownerId: 'Shashank Bharadwaj', deadSalary: 0 }
  // ];

  constructor(private db: AngularFirestore) {
    db.collection('owners')
      .valueChanges()
      .subscribe(owners => {
        this.owners = owners;
      });
  }

  getOwner(ownerId) {
    return this.owners.find(owner => {
      return owner.ownerId === ownerId;
    });
  }

  getAllOwners() {
    return this.owners;
  }
}
